import { render, staticRenderFns } from "./memoryday.vue?vue&type=template&id=2e94abd7"
import script from "./memoryday.vue?vue&type=script&lang=js"
export * from "./memoryday.vue?vue&type=script&lang=js"
import style0 from "./memoryday.vue?vue&type=style&index=0&id=2e94abd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports